<template>
      <div
        class="modal trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Trader Info</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputEmail4">First Name</label>
                            <input  type="text" class="form-control" id="inputEmail4" :disabled="true" v-model="traderInfo.firstName" >
                        </div>
                        <div class="form-group col-md-6">
                            <label for="inputLast">Last Name</label>
                            <input type="text" class="form-control" id="inputLast" :disabled="true" v-model="traderInfo.lastName" >
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputPhone">Phone Number</label>
                            <input type="text" class="form-control" id="inputPhone" :disabled="true" v-model="traderInfo.phone"></div>
                        <div class="form-group col-md-6">
                            <label for="inputLocation">Location</label>
                            <input type="text" class="form-control" :disabled="true" v-model="traderInfo.address">

                            <!-- <select class="form-control" :disabled="true" v-model="traderInfo.location" >
                            <option value="">Please select</option>
                            <option value="Remote">Remote</option>
                            <option value="Office">Office</option>
                            </select> -->
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                        <label for="inputAddress">Email</label>
                        <input type="email" class="form-control" id="inputAddress" :disabled="true" v-model="traderInfo.email" ></div>
                        <div  class="form-group col-md-6">
                        <label class="typo__label">User Roles</label>
                         <input type="text" class="form-control" id="inputPassword4" :disabled="true" :value="getUserGroupNames(traderInfo.userGroups)" >   
                        </div>
                    </div>

                    <div class="modal-footer bid">
                        <button type="button" class="btn btn-primary"  @click="$emit('close')">Close</button>
                    </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>

    <script>
        export default {
            name: 'traderModal',
            props: ['traderInfo'],
            methods: {
                getUserGroupNames(group){
                  if(!group){
                    return "N/A"
                  }
                    var removedTenantName = group.map((groupName) => {
                        return groupName.split('-')[1]
                    });
                    return removedTenantName.join(', ');
                }      
            }
        };
    </script>